var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.34544 18H15.6543C16.8472 18 17.8179 17.0294 17.8179 15.8363V3.97995C17.8179 2.78698 16.8474 1.81628 15.6543 1.81628H15.6439V2.8491C15.6439 3.5933 15.0387 4.19852 14.2945 4.19852H14.1353C13.3911 4.19852 12.7859 3.59332 12.7859 2.8491V1.81648H5.21374V2.8493C5.21374 3.5935 4.60854 4.19872 3.86432 4.19872H3.70514C2.96112 4.19872 2.35572 3.59352 2.35572 2.8493V1.81648H2.34531C1.15234 1.81648 0.181641 2.78705 0.181641 3.98015V15.8363C0.181901 17.0294 1.15247 18 2.34547 18L2.34544 18ZM1.42467 6.58795H16.575V15.8361C16.575 16.3439 16.162 16.7569 15.6542 16.7569L2.3454 16.757C1.83759 16.757 1.42464 16.3439 1.42464 15.8362L1.42467 6.58795Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.87793 7.78113H5.47176V9.85613H2.87793V7.78113Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.09473 7.78113H8.68856V9.85613H6.09473V7.78113Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.31152 7.78113H11.9054V9.85613H9.31152V7.78113Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.5273 7.78113H15.1212V9.85613H12.5273V7.78113Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.87793 10.4788H5.47176V12.5538H2.87793V10.4788Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.09473 10.4788H8.68856V12.5538H6.09473V10.4788Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.31152 10.4788H11.9054V12.5538H9.31152V10.4788Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.5273 10.4788H15.1212V12.5538H12.5273V10.4788Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M2.87793 13.1766H5.47176V15.2516H2.87793V13.1766Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M6.09473 13.1766H8.68856V15.2516H6.09473V13.1766Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.31152 13.1766H11.9054V15.2516H9.31152V13.1766Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.5273 13.1766H15.1212V15.2516H12.5273V13.1766Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M3.70535 3.61914H3.86453C4.28894 3.61914 4.63433 3.27376 4.63433 2.84934V0.769678C4.63452 0.345261 4.28894 -0.00012207 3.86453 -0.00012207H3.70535C3.28093 -0.00012207 2.93555 0.345261 2.93555 0.769678V2.84934C2.93574 3.27376 3.28093 3.61914 3.70535 3.61914Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M14.135 3.61914H14.2942C14.7186 3.61914 15.064 3.27376 15.064 2.84934V0.769678C15.064 0.345261 14.7186 -0.00012207 14.2942 -0.00012207H14.135C13.7106 -0.00012207 13.3652 0.345261 13.3652 0.769678V2.84934C13.3652 3.27376 13.7106 3.61914 14.135 3.61914Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDisabled);
export default __webpack_public_path__ + "static/media/calendarDisabled.539aee12cb3b89354c359aec7ec1bf02.svg";
export { ForwardRef as ReactComponent };